export const paymentsEn = {
  // BEGIN Michael
  PAYMENT: 'Payment',
  PAYMENTS: 'Payments',
  PAYMENT_PREVIEW: 'Payment Preview',
  PAYMENT_CREATED_SUCCESSFULLY: 'Payment created successfully',
  PAYMENT_ASSIGN_SUCCESSFULLY: 'Payment assigned successfully',
  PAYMENT_GL_CODE_PREVIEW: 'This payment will post to GL Code: {glCode} (Default GL Code)',
  PAYMENT_GL_CODE_PREVIEW_CUSTOM: 'This payment will post to GL Code: {glCode} (Custom GL Code)',
  PAYMENT_WARNING_MESSAGE:
    'Total Invoices Payment must be equal to the payment amount. Please adjust the invoice balances and try again.',
  REMITTER: 'Remitter',
  PAYMENT_DETAILS: 'Payment Details',
  TOTAL_PAYMENT: 'Payment Total',

  OVER_MESSAGE: 'Warning! Total Invoices Payment exceeds Payment Total',
  UNDER_MESSAGE: 'Warning! Total Invoices Payment is less than Payment Total',
  EQUALS_MESSAGE: 'The total balance is equal than the payment amount',

  DEBTOR_FILTER_INFO: 'Filtering by invoices of the same debtor',

  VALIDATION_MAX_MESSAGE: 'The amount must be equal or less than the Invoice balance ',
  CLICK_HERE_TO_SEE_PAYMENT: 'Click here to see the payment.',
  NUMBER_OF_DOCUMENTS: 'N° Documents',
  DOCUMENTS_ADDED_PAYMENT: 'All documents were successfully added to the payment.',
  PAYMENT_APPLICATION_CONFIRMATION: 'Are you sure that you want to apply this payment to these invoices?',
  PAYMENT_APPLICATION_CONFIRMATION_OA: 'Are you sure that you want to apply this payment to these over advances?',
  PAYMENT_APPLICATION_CONFIRMATION_BOTH: 'Are you sure that you want to apply this payment to these invoices/over advances?',
  DELETE_OOS_INVOICE_CONFIRMATION: 'Are you sure you want to delete OOS invoice [{invoiceNumber}]?',
  ADD_SPLIT: 'Add Split',
  CANCELLED: 'Cancelled',
  CANCEL_PAYMENT: 'Cancel Payment',
  CANCEL_PAYMENTS_SUCCESS: 'Payments cancelled successfully',
  CONFIRM_CANCELLATION: 'Confirm Cancellation',
  CANCEL_DIALOG_FIRST_BODY_TEXT: 'Are you sure you want to cancel those payments?',
  UNABLE_TO_SELECT_PAYMENT_APPLIED: 'Unable to select payment when in Applied state.',
  UNABLE_TO_SELECT_PAYMENT_CANCELLED: 'Unable to select payment when in Cancelled state.',
  UNABLE_TO_CANCEL_PAYMENT_NOT_UNAPPLIED: 'Unable to cancel payment when not in Unapplied state.',
  UNABLE_TO_SELECT_PAYMENT: 'Unable to select payment, not actions available.',
  IMPORT_PAYMENTS: 'Import Payments',
  TRANSACTION_ID: 'Transaction ID',
  PAYMENT_AMOUNT: 'Payment Amount',
  MAX_LENGTH_ACCOUNT_100: 'The account name must be less than 100 characters',
  OVER_AMOUNT: 'Over Amount',
  APPLIED_AMOUNT: 'Applied Amount',
  PAID_SHORT_PARTIAL: 'Paid Short Partial',
  SHORT: 'Short Partial',
  OVER: 'Over',
  CLOSED_PAID: 'Closed Paid',
  CREATED_DATE: 'Created Date',
  PAYMENT_APPLIED: 'Payment Applied',
  SOME_INVOICES_ARE_HIDDEN: 'Some selected invoices are hidden by the current filters or pagination.',
  SOME_OAS_ARE_HIDDEN: 'Some selected over advances are hidden by the current filters or pagination.',
  OA_FEATURE_DISABLED_WITH_SELECTION: 'Over Advances are selected, but the Over Advance feature is not enabled. Please remove them from the selection before applying the payment.',
  MULTI_SELECT_BLOCKED_BY_OA: 'To select invoices, clear the current over advance selections first.',
  MULTI_SELECT_BLOCKED_BY_INVOICE: 'To select over advances, clear the current invoice selections first.',
  CREATE_DRAFT_PAYMENTS: 'Create Draft Payments',
  CREATE_DRAFT_PAYMENT_MESSAGE: 'Create payments to select document for assigning',
  PAGES_ATTACHED_SUCCESSFULLY: 'Pages attached successfully',
  CONFIRM_APPLY_PAGES_TITLE: 'Confirm Apply Pages',
  CONFIRM_APPLY_PAGES_MESSAGE:
    'Some payments already have pages attached. The previous pages will be replaced with the new ones. Do you want to continue?',
  CONFIRM_DELETE_DRAFT_PAYMENT_TITLE: 'Confirm Delete Draft Payment',
  CONFIRM_DELETE_DRAFT_PAYMENT_MESSAGE:
    'Are you sure you want to delete this draft payment? This action is not reversible.',
  DRAFT_PAYMENT_DELETE_SUCCESS: 'Draft Payment deleted successfully',
  NO_OF_PAYMENTS: 'No. of Payments',
  BATCH_NO: 'Batch No.',
  BATCH_PAYMENT_CREATED_SUCCESSFULLY: 'Batch Payment created successfully',
  CONFIRM_BATCH_PAYMENT: 'Confirm Batch Payment',
  PAYMENT_BATCH_FORCE_CLOSED_SUCCESSFULLY: 'Batch Payment force closed successfully',
  ALL_PAYMENTS_FINISHED_CLOSE_BATCH: 'All payments are finished. You can close this blade now.',
  APPLY_AR_BALANCE: 'Apply AR Balance',
  APPLY_REMAINING: 'Apply Remaining',
  AR_BALANCE: 'AR Balance',
  REMAINING: 'Remaining',
  REFERENCE: 'Reference',
  PAYMENT_AMOUNT_CANNOT_BE_NEGATIVE: 'Payment amount cannot be negative',
  FULL_PAYMENT_AMOUNT_LESS_INVOICE_BALANCE: "Full payment amount is less than the invoice's current balance",
  PAYMENT_AMOUNT_OVER_INVOICE_AMOUNT: 'The payment amount is over than the invoice amount',
  PAYMENT_AMOUNT_LESS_OA_BALANCE: 'Payment is less than the over advance balance',
  PAYMENT_AMOUNT_EXCEEDS_OA_BALANCE: 'Payment exceeds over advance balance',
  PAYMENT_AMOUNT_MUST_BE_POSITIVE: 'Payment amount must be greater than 0',
  PRINCIPAL_BALANCE: 'Principal Balance',
  OVERALL_BALANCE: 'Overall Balance',
  DRAFT_PAYMENT: 'Draft Payment',
  DRAFT_PAYMENTS: 'Draft Payments',
  EDIT_DRAFT_PAYMENT: 'Edit Draft Payment',
  FIELDS_REQUIRED_ONLY_WHEN_CRATE_PAYMENT_BATCH: 'These fields are required only when creating the Payment Batch.',
  APPLY: 'Apply',
  TYPE_TOOLTIP_ARIA: 'Payment type help',
  TYPE_TOOLTIP_SHORT: 'Short payment — Part keeps the invoice open; Full uses reserves to close it.',
  TYPE_TOOLTIP_OVER: 'Over payment — Cash sends the excess to cash reserve; Credit leaves it on the invoice as a credit to action later.',
  OVER_CREDIT_INFO:
    "{cleared} clears invoice {invoice} · -{credit} stays on {company}'s AR aging as a credit · This payment won't be able to be withdrawn afterward.",
  NO_PAGES_ASSIGNED_WARNING_MESSAGE: 'No pages are assigned to any of the payments.',
  CONFIRM_CREATE_PAYMENT_BATCH: 'Confirm Create Payment Batch',
  CONFIRM_CREATE_PAYMENT_BATCH_MESSAGE:
    'Some payments already have a batch number and user assigned. Do you want to continue and replace the batch for these payments?',
  CLEAR_BATCH: 'Clear Batch',
  CONFIRM_CLEAR_PAYMENT_BATCH: 'Confirm Clear Payment Batch',
  CONFIRM_CLEAR_PAYMENT_BATCH_MESSAGE:
    'Are you sure you want to clear the batch for the selected payments? This action is not reversible. (Selected payments without batch will not be affected)',
  RELOAD_PAGE_INVOICE_NUMBERS_MESSAGE:
    'Any changes applied to the invoice numbers require the page to be reloaded for the selection to be reflected in the table.',
  SKIP_PAYMENT: 'Skip Payment',
  MESSAGE_SKIP_PAYMENT:
    'Are you sure you want to skip the payment? This action will move the payment to the end of the queue.',
  REMOVE_PAYMENT: 'Remove Payment',
  MESSAGE_REMOVE_PAYMENT:
    'Are you sure you want to remove the payment? This action will remove the payment from the queue',
  APPLY_AND_SPLIT: 'Apply & Split',
  APPLY_AND_SPLIT_CONFIRMATION_MESSAGE:
    'This action will close this payment with the Total Invoices Payment [{totalPayment}] and create a new payment with the remaining amount [{paymentBalance}]',
  // END Michael
  // BEGIN Fco
  BTN_OVER: 'Over',
  BTN_FULL: 'Full',
  BTN_PART: 'Part',
  BTN_CASH: 'Cash',
  BTN_CREDIT: 'Credit',
  WARNING_LESS_INVOICE_BALANCE: "Full payment amount is less than the invoice's current balance",
  WARNING_OVER_INVOICE_BALANCE: 'The payment amount is over than the invoice amount',
  PAYMENT_BACKDATING_WARNING:
    'You are entering a payment with a past date. Please note that any accrued fees will be automatically recalculated based on the payment date you provide. (This only applies for Terms with Collection Fees charged on full payment)',
  // END Fco
  // BEGIN Fabian
  UNAPPLIED: 'Unapplied',
  APPLIED: 'Applied',
  TRANSACTION_REF: 'Transaction Ref',
  PAYMENT_TYPE: 'Payment Type',
  PAYMENT_DATE: 'Payment Date',
  PAYMENT_DATE_OVERRIDDEN: 'Payment Date (Overrides AI-detected date)',
  GROUP_PAYMENTS: 'Group Payments',
  GROUP_PAYMENTS_HELPER: 'Enable to group all payments in the document',
  ALERT_PAYMENT_CSV: 'Only one file is allowed and it must be a .csv file.',
  PAYMENT_CSV_SUCCESS: 'Payments have been added correctly.',
  UPLOAD_DOCUMENTS: 'Upload Documents',
  SUBMIT_DOCUMENTS: 'Submit Documents',
  UPLOAD_CSV: 'Upload CSV',
  PAYMENT_CSV_ERROR: 'Only CSV files are allowed.',
  TEXT_DOCUMENT_UPLOAD:
    'In the following link you will find a template for the format of the document to be uploaded. ',
  DOWNLOAD_CSV: 'Download CSV template',
  TOTAL_UNAPPLIED_AMOUNT: 'Total Unapplied Amount',
  TOTAL_APPLIED_AMOUNT: 'Total Applied Amount',
  TOTAL_CANCELLED_AMOUNT: 'Total Cancelled Amount',
  SELECTED_PAYMENT_AMOUNT: 'Selected Payment Amount',
  SEE_MORE: 'See more',
  SEE_LESS: 'See less',
  EXPORT_PAYMENTS_SUCCESSES: 'Payments exported successfully',
  ARE_YOU_SURE_EXPORT_PAYMENTS: 'Are you sure you want to export the payments?',
  EXPORT_PAYMENTS: 'Export Payments',
  PAYMENT_BATCH_DOCUMENTS_UPLOAD_MESSAGE:
    'After submitting documents you will not be able to upload or remove documents, please review and submit document for create/assigning payments',
  PAYMENT_NO_DOCUMENT_UPLOAD_MESSAGE:
    'Once all documents are uploaded, you will be able to create payments and assign them. Until then, creating payments will be disabled.',
  CREATE_BATCH_PAYMENT: 'Create Batch Payment',
  CREATE_BATCH_PAYMENTS: 'Create Batch Payments',
  CONFIRM_DOCUMENTS: 'Confirm Documents!',
  BANK_REMIT: 'Bank Remit',
  DEBTOR_REMIT: 'Debtor Remit',
  OTHER_DOCUMENT: 'Other',
  DOCUMENT_TYPE: 'Document Type',
  ADD_MORE_DOCUMENTS: 'Add More Documents',
  CREATE_PAYMENTS: 'Create Payments',
  APPLY_PAYMENTS: 'Apply Payments',
  EDIT_PAYMENT: 'Edit Payment',
  CONFIRM: 'Confirm',
  FORCE_CLOSE: 'Force Close',
  MESSAGE_FORCE_CLOSE: 'Are you sure to force close this payment batch?',
  PAYMENT_NOT_NEGATIVE: 'Payment amount cannot be negative',
  SELECTED_DOCUMENTS_ENABLED_PAYMENT: 'Select documents to enable assign payments',
  DOCUMENTS_UPLOAD_ERROR: 'The following files had problems when trying to upload them.',
  DOCUMENTS_UPLOAD_INFO_TEXT:
    'An error has occurred, in order to continue please force close the current payment batch. Press Force close.',
  HAVE_CREATED_QUEUE: 'You already have a queue saved',
  REPLACE_QUEUE_CONFIRMATION: 'Do you want to replace it with the current selection?',
  REPLACE: 'Replace',
  CLEAR_QUEUE: 'Clear Queue',
  QUEUE_PAYMENTS: 'Queue Payments',
  APPLYING: 'Applying',
  CLEAR_PAYMENT_QUEUE: 'Clear Payment Queue',
  MESSAGE_CLEAR_PAYMENT_QUEUE: 'Are you sure you want to clear the payment queue?',
  QUEUE_PROCESSING_COMPLETE: "You've successfully applied all payments in the queue, the queue has been cleared.",
  CONTINUE_QUEUE: 'Continue Queue',
  PAYMENT_LIST_QUEUE_MESSAGE: 'You currently have an active queue. You can perform one of these actions on it.',
  PAYMENT_ORIGINAL_INFORMATION: 'Payment Original Information',
  ORIGINAL_PAYMENT: 'Original Payment',
  ORIGINAL_AMOUNT: 'Original Amount',
  SPLIT_DATE: 'Split Date',
  GENERATED_PAYMENT_SPLIT: 'Generated Payment Split',
  PAYMENT_SPLIT_INFORMATION: 'Payment Split Information',
  SPLIT_INFORMATION: 'Split Information',
  // END Fabian
  //BEGIN Esteban
  PAYMENT_UPDATE: 'Payment Update',
  PAYMENT_UPDATE_SUCCESS: 'Payment updated successfully',
  ONLY_ZERO_BALANCE: 'Zero balance invoices',
  IMPORT_INVOICES: 'Import Invoices',
  ALERT_INVOICE_CSV: 'Only one file is allowed and it must be a .csv file.',
  INVOICE_CSV_SUCCESS: 'Invoices have been added correctly.',
  WITHDRAW_PAYMENT: 'Withdraw Payment',
  WITHDRAW_DIALOG_FIRST_BODY_TEXT: 'Are you sure you want to withdraw the selected payment(s)?',
  CONFIRM_WITHDRAW: 'Confirm Withdraw',
  UNABLE_TO_WITHDRAW_PAYMENT_APPLIED: 'The payment can only be withdrew on the same day it was applied.',
  UNABLE_TO_WITHDRAW_PAYMENT_HAS_CREDIT: "This payment can't be withdrawn because it generated a credit.",
  WITHDRAW_PAYMENTS_SUCCESS: 'Payments withdrawn successfully',
  DOWNLOAD_NACHA_FILE: 'Download NACHA File',
  DOWNLOAD_NACHA_FILE_V1: 'Download NACHA File V1',
  DOWNLOAD_NACHA_FILE_V2: 'Download NACHA File V2',
  BODY_DOWNLOAD_NACHA_FILE: 'Download NACHA file?',
  EXPORT_NACHA_FILE_SUCCEED: 'NACHA file exported successfully',
  DOWNLOAD_EFT_FILE: 'Download EFT File',
  BODY_DOWNLOAD_EFT_FILE: 'Download EFT file?',
  EXPORT_EFT_FILE_SUCCEED: 'EFT file exported successfully. It is ready for download.',
  EXPORT_EFT_FILE_FAILED: 'Failed to export the EFT file. Try again.',
  DOWNLOAD_EFT_FILE_CAD: 'Download CAD EFT File',
  DOWNLOAD_EFT_FILE_USD: 'Download USD EFT File',
  DOWNLOAD_EFT_FILE_CURRENCY: 'Download {currency} EFT File',
  EXPORT_EFT_FILE_SUCCEED_CURRENCY:
    '{currency} EFT file exported successfully. It is ready for download.',
  EXPORT_EFT_FILE_FAILED_CURRENCY: 'Failed to export the {currency} EFT file. Try again.',
  PAYMENT_CHANNEL: 'Payment Channel',
  //END Esteban

  // BEGIN Patricio
  DOWNLOAD_DISBURSEMENT_CSV: 'Download Disbursement CSV',
  BODY_DOWNLOAD_DISBURSEMENT_CSV: 'Are you sure you want to download the Disbursement CSV file?',
  // END Patricio
  FULL: 'Full',
  SHORT_FULL: 'Short Full',

  PREVIEW_BALANCE_LESS_THAN_PAYMENT_TOTAL: 'Preview balance is less than the payment total',
  PREVIEW_BALANCE_EXCEEDS_PAYMENT_TOTAL: 'Preview balance exceeds the payment total',
  PREVIEW_BALANCE_PAID_IN_FULL: 'Preview balance is paid in full',

  BATCH_NUMBER: 'Batch Number',
  BATCH_USER: 'Batch User',
  CREATE_BATCH: 'Create Batch',
  CREATE_PAYMENT_BATCH: 'Create Payment Batch',
  PAYMENT_BATCH_CREATED_SUCCESSFULLY: 'Payment Batch created successfully',
  UNABLE_TO_BATCH_PAYMENT:
    'Unable to create batch when a selected payment is not Unapplied or already belongs to a batch',

  // Reconciliation
  RECONCILE_DRAFT_PAYMENTS: 'Reconcile Draft Payments',
  RECONCILIATION: 'Reconciliation',
  DEBTOR_REMITTANCE: 'Debtor Remittance',
  BANK_REMITTANCE: 'Bank Remittance',
  RECONCILIATION_STATUS: 'Status',
  READY_TO_APPLY: 'Ready to Apply',
  MISMATCH: 'Mismatch',
  MISSING_BANK_REMIT: 'Missing Bank Remit',
  MISSING_DEBTOR_REMIT: 'Missing Debtor Remit',
  LIKELY_MATCH: 'Likely Match',
  POTENTIAL_MATCH: 'Potential Match',
  POSSIBLE_MATCH: 'Possible Match',
  USER_MATCH: 'User Matched',
  UNMATCH: 'Unmatch',
  DELETE_DEBTOR_RM: 'Delete Debtor RM',
  DELETE_BANK_RM: 'Delete Bank RM',
  MOVE_BANK_REMITTANCE: 'Move Bank Remittance',
  MOVE_DEBTOR_REMITTANCE: 'Move Debtor Remittance',
  SEARCH_DEBTOR_REMITTANCE: 'Search for Debtor Remittance',
  SEARCH_BANK_REMITTANCE: 'Search for Bank Remittance',
  MATCH_TO_SELECTED: 'Match To Selected Debtor Remittance',
  MATCH_TO_SELECTED_BANK: 'Match To Selected Bank Remittance',
  NO_PAYMENTS_TO_RECONCILE: 'No payments available to reconcile.',
  CONFIRM_DELETE_DEBTOR_RM_TITLE: 'Delete Debtor Remittance',
  CONFIRM_DELETE_DEBTOR_RM_MESSAGE: 'Are you sure you want to delete this Debtor Remittance payment?',
  CONFIRM_DELETE_BANK_RM_TITLE: 'Delete Bank Remittance',
  CONFIRM_DELETE_BANK_RM_MESSAGE: 'Are you sure you want to delete this Bank Remittance payment?',
  CREATE_PAYMENT_FROM_RECONCILE: 'Create Payment',
  CREATE_SELECTED_PAYMENTS: 'Create Selected Payments',
  PAYMENTS_CREATED_SUCCESSFULLY: 'Payments created successfully',

  OVER_ADVANCE_DETAILS: 'Over Advance Details',
  OVER_ADVANCE_TYPE: 'Over Advance Type',
  WITHDRAW_OVER_ADVANCE_PAYMENT: 'Withdraw Over Advance Payment',
  WITHDRAW_OVER_ADVANCE_DIALOG_BODY: 'Are you sure you want to withdraw this payment from the over advance?',
  WITHDRAW_OVER_ADVANCE_SUCCESS: 'Payment withdrawn from over advance successfully',
}

export const paymentsEs: typeof paymentsEn = {
  // BEGIN Michael
  PAYMENT: 'Pago',
  PAYMENTS: 'Pagos',
  PAYMENT_CREATED_SUCCESSFULLY: 'Pago creado exitosamente',
  PAYMENT_ASSIGN_SUCCESSFULLY: 'Pago asignado exitosamente',
  PAYMENT_GL_CODE_PREVIEW: 'Este pago se registrará con el GL Code: {glCode} (Default GL Code)',
  PAYMENT_GL_CODE_PREVIEW_CUSTOM: 'Este pago se registrará con el GL Code: {glCode} (Custom GL Code)',
  PAYMENT_WARNING_MESSAGE:
    'El pago total de las facturas debe ser igual al monto del pago. Ajuste los saldos de las facturas e intente nuevamente.',
  REMITTER: 'Remitente',
  PAYMENT_PREVIEW: 'Vista previa del pago',
  PAYMENT_DETAILS: 'Detalles del pago',
  TOTAL_PAYMENT: 'Pago total',
  OVER_MESSAGE: '¡Advertencia! El pago total de las facturas excede el monto del pago',
  UNDER_MESSAGE: '¡Advertencia! El pago total de las facturas es menor que el monto del pago',
  EQUALS_MESSAGE: 'El balance total es igual al monto del pago',

  DEBTOR_FILTER_INFO: 'Filtrado por facturas del mismo deudor',

  VALIDATION_MAX_MESSAGE: 'El monto debe ser igual o menor que el balance de la factura',
  CLICK_HERE_TO_SEE_PAYMENT: 'Haga clic aquí para ver el pago',
  NUMBER_OF_DOCUMENTS: 'N° Documentos',
  DOCUMENTS_ADDED_PAYMENT: 'Todos los documentos se agregaron correctamente al pago.',
  PAYMENT_APPLICATION_CONFIRMATION: '¿Está seguro de que desea aplicar este pago a estas facturas?',
  PAYMENT_APPLICATION_CONFIRMATION_OA: '¿Está seguro de que desea aplicar este pago a estos over advances?',
  PAYMENT_APPLICATION_CONFIRMATION_BOTH: '¿Está seguro de que desea aplicar este pago a estas facturas/over advances?',
  DELETE_OOS_INVOICE_CONFIRMATION: '¿Está seguro de que desea eliminar la factura OOS [{invoiceNumber}]?',
  ADD_SPLIT: 'Agregar Split',
  CANCELLED: 'Cancelado',
  CANCEL_PAYMENT: 'Cancelar Pago',
  CANCEL_PAYMENTS_SUCCESS: 'Pagos cancelados exitosamente',
  CONFIRM_CANCELLATION: 'Confirmar Cancelación',
  CANCEL_DIALOG_FIRST_BODY_TEXT: '¿Está seguro de que desea cancelar esos pagos?',
  UNABLE_TO_SELECT_PAYMENT_APPLIED: 'No se puede seleccionar el pago cuando está en estado Aplicado.',
  UNABLE_TO_SELECT_PAYMENT_CANCELLED: 'No se puede seleccionar el pago cuando está en estado Cancelado.',
  UNABLE_TO_CANCEL_PAYMENT_NOT_UNAPPLIED: 'No se puede cancelar el pago cuando no está en estado No aplicado.',
  UNABLE_TO_SELECT_PAYMENT: 'No se puede seleccionar el pago, no hay acciones disponibles.',
  IMPORT_PAYMENTS: 'Importar Pagos',
  TRANSACTION_ID: 'Id de transacción',
  PAYMENT_AMOUNT: 'Monto del pago',
  MAX_LENGTH_ACCOUNT_100: 'El nombre de la cuenta debe ser menor a 100 caracteres',
  OVER_AMOUNT: 'Monto excedido',
  APPLIED_AMOUNT: 'Monto aplicado',
  PAID_SHORT_PARTIAL: 'Pago Parcial',
  SHORT: 'Corto Parcial',
  OVER: 'Excedido',
  CLOSED_PAID: 'Cerrado Pagado',
  CREATED_DATE: 'Fecha de creación',
  PAYMENT_APPLIED: 'Pago aplicado',
  SOME_INVOICES_ARE_HIDDEN: 'Algunas facturas están ocultas por los filtros o la paginación actuales.',
  SOME_OAS_ARE_HIDDEN: 'Algunos over advances están ocultos por los filtros o la paginación actuales.',
  OA_FEATURE_DISABLED_WITH_SELECTION: 'Hay Over Advances seleccionados, pero la funcionalidad no está habilitada. Por favor, quítelos de la selección antes de aplicar el pago.',
  MULTI_SELECT_BLOCKED_BY_OA: 'Para seleccionar facturas, primero limpia las selecciones de over advances.',
  MULTI_SELECT_BLOCKED_BY_INVOICE: 'Para seleccionar over advances, primero limpia las selecciones de facturas.',
  CREATE_DRAFT_PAYMENTS: 'Crear Pagos en Borrador',
  CREATE_DRAFT_PAYMENT_MESSAGE: 'Cree pagos para seleccionar documentos para asignar',
  PAGES_ATTACHED_SUCCESSFULLY: 'Páginas adjuntas exitosamente',
  CONFIRM_APPLY_PAGES_TITLE: 'Confirmar Aplicación de Páginas',
  CONFIRM_APPLY_PAGES_MESSAGE:
    'Algunos pagos ya tienen páginas adjuntas. Las páginas anteriores se reemplazarán por las nuevas. ¿Desea continuar?',
  CONFIRM_DELETE_DRAFT_PAYMENT_TITLE: 'Confirmar Eliminación de Pago en Borrador',
  CONFIRM_DELETE_DRAFT_PAYMENT_MESSAGE:
    '¿Está seguro de que desea eliminar este pago en borrador? Esta acción no se puede deshacer.',
  DRAFT_PAYMENT_DELETE_SUCCESS: 'Pago en borrador eliminado exitosamente',
  NO_OF_PAYMENTS: 'N° de Pagos',
  BATCH_NO: 'N° de Lote',
  BATCH_PAYMENT_CREATED_SUCCESSFULLY: 'Lote de pagos creado exitosamente',
  CONFIRM_BATCH_PAYMENT: 'Confirmar Lote de Pagos',
  PAYMENT_BATCH_FORCE_CLOSED_SUCCESSFULLY: 'Se forzó el cierre del lote de pagos exitosamente',
  ALL_PAYMENTS_FINISHED_CLOSE_BATCH: 'Todos los pagos están finalizados. Puede cerrar esta ventana ahora.',
  APPLY_AR_BALANCE: 'Aplicar saldo de AR',
  APPLY_REMAINING: 'Aplicar restante',
  AR_BALANCE: 'Saldo AR',
  REMAINING: 'Restante',
  REFERENCE: 'Referencia',
  PAYMENT_AMOUNT_CANNOT_BE_NEGATIVE: 'El monto del pago no puede ser negativo',
  FULL_PAYMENT_AMOUNT_LESS_INVOICE_BALANCE: 'El monto total del pago es menor que el saldo actual de la factura',
  PAYMENT_AMOUNT_OVER_INVOICE_AMOUNT: 'El monto del pago es mayor que el monto de la factura',
  PAYMENT_AMOUNT_LESS_OA_BALANCE: 'El pago es menor que el saldo del over advance',
  PAYMENT_AMOUNT_EXCEEDS_OA_BALANCE: 'El pago excede el saldo del over advance',
  PAYMENT_AMOUNT_MUST_BE_POSITIVE: 'El monto del pago debe ser mayor que 0',
  PRINCIPAL_BALANCE: 'Saldo principal',
  OVERALL_BALANCE: 'Saldo total',
  DRAFT_PAYMENT: 'Pago en borrador',
  DRAFT_PAYMENTS: 'Pagos en borrador',
  EDIT_DRAFT_PAYMENT: 'Editar Pago en Borrador',
  FIELDS_REQUIRED_ONLY_WHEN_CRATE_PAYMENT_BATCH: 'Estos campos son requeridos solo al crear el lote de pagos.',
  APPLY: 'Aplicar',
  TYPE_TOOLTIP_ARIA: 'Ayuda sobre el tipo de pago',
  TYPE_TOOLTIP_SHORT: 'Pago corto — Parcial deja la factura abierta; Completo usa reservas para cerrarla.',
  TYPE_TOOLTIP_OVER: 'Pago mayor al balance — Efectivo manda el excedente al cash reserve; Crédito lo deja en la factura como crédito para accionar después.',
  OVER_CREDIT_INFO:
    '{cleared} salda la factura {invoice} · -{credit} queda como crédito en el AR aging de {company} · Este pago no podrá ser retirado luego.',
  NO_PAGES_ASSIGNED_WARNING_MESSAGE: 'No hay páginas asignadas a ninguno de los pagos.',
  CONFIRM_CREATE_PAYMENT_BATCH: 'Confirmar Crear Lote de Pagos',
  CONFIRM_CREATE_PAYMENT_BATCH_MESSAGE:
    'Algunos pagos ya tienen un número de lote y usuario asignado. ¿Desea continuar y reemplazar el lote para estos pagos?',
  CLEAR_BATCH: 'Limpiar Lote',
  CONFIRM_CLEAR_PAYMENT_BATCH: 'Confirmar Limpiar Lote de Pagos',
  CONFIRM_CLEAR_PAYMENT_BATCH_MESSAGE:
    '¿Está seguro de que desea limpiar el lote para los pagos seleccionados? Esta acción no se puede deshacer. (Los pagos seleccionados sin lote no se verán afectados)',
  RELOAD_PAGE_INVOICE_NUMBERS_MESSAGE:
    'Cualquier cambio aplicado a los números de factura requiere que la página se recargue para que la selección se refleje en la tabla.',
  SKIP_PAYMENT: 'Saltar Pago',
  MESSAGE_SKIP_PAYMENT: '¿Está seguro de que desea saltar el pago? Esta acción moverá el pago al final de la cola.',
  REMOVE_PAYMENT: 'Eliminar Pago',
  MESSAGE_REMOVE_PAYMENT: '¿Está seguro de que desea remover el pago? Esta acción removerá el pago de la cola. ',
  APPLY_AND_SPLIT: 'Aplicar y Dividir',
  APPLY_AND_SPLIT_CONFIRMATION_MESSAGE:
    'Esta acción cerrará este pago con el Pago Total de las Facturas [{totalPayment}] y creará un nuevo pago con el monto restante [{paymentBalance}]',
  // END Michael
  // BEGIN Fco
  BTN_OVER: 'Sobr',
  BTN_FULL: 'Comp',
  BTN_PART: 'Parc',
  BTN_CASH: 'Efectivo',
  BTN_CREDIT: 'Crédito',
  WARNING_LESS_INVOICE_BALANCE: 'El importe total del pago es inferior al saldo actual de la factura',
  WARNING_OVER_INVOICE_BALANCE: 'El importe del pago es superior al de la factura',
  PAYMENT_BACKDATING_WARNING:
    'Está ingresando un pago con una fecha pasada. Tenga en cuenta que cualquier cargo acumulado se recalculará automáticamente según la fecha de pago que proporcione. (Solo se aplica a los términos con cargos por cobranza cobrados al pago total)',
  // END Fco
  // BEGIN Fabian
  UNAPPLIED: 'No aplicado',
  APPLIED: 'Aplicado',
  TRANSACTION_REF: 'Referencia de transacción',
  PAYMENT_TYPE: 'Tipo de pago',
  PAYMENT_DATE: 'Fecha de pago',
  PAYMENT_DATE_OVERRIDDEN: 'Fecha de pago (anula la fecha detectada por IA)',
  GROUP_PAYMENTS: 'Agrupar Pagos',
  GROUP_PAYMENTS_HELPER: 'Habilitar para agrupar todos los pagos en el documento',
  ALERT_PAYMENT_CSV: 'Solo se permite un archivo y debe ser un archivo .csv.',
  PAYMENT_CSV_SUCCESS: 'Los pagos se han agregado correctamente.',
  UPLOAD_DOCUMENTS: 'Subir documentos',
  SUBMIT_DOCUMENTS: 'Entregar documentos',
  UPLOAD_CSV: 'Subir CSV',
  PAYMENT_CSV_ERROR: 'Solo se permiten archivos CSV.',
  TEXT_DOCUMENT_UPLOAD:
    'En el siguiente enlace encontrará una plantilla para el formato del documento que debe cargar. ',
  DOWNLOAD_CSV: 'Descargar plantilla CSV',
  TOTAL_UNAPPLIED_AMOUNT: 'Monto total no aplicado',
  TOTAL_APPLIED_AMOUNT: 'Monto total aplicado',
  TOTAL_CANCELLED_AMOUNT: 'Monto total cancelado',
  SELECTED_PAYMENT_AMOUNT: 'Monto del pago seleccionado',
  SEE_MORE: 'Ver más',
  SEE_LESS: 'Ver menos',
  EXPORT_PAYMENTS_SUCCESSES: 'Pagos exportados exitosamente',
  ARE_YOU_SURE_EXPORT_PAYMENTS: '¿Está seguro de que desea exportar los pagos?',
  EXPORT_PAYMENTS: 'Exportar Pagos',
  PAYMENT_BATCH_DOCUMENTS_UPLOAD_MESSAGE:
    'Después de entregar los documentos, no podrá cargar ni eliminar documentos, revise y entregue el documento para crear/asignar pagos',
  PAYMENT_NO_DOCUMENT_UPLOAD_MESSAGE:
    'Una vez que se hayan cargado todos los documentos, podrá crear pagos y asignarlos. Hasta entonces, la creación de pagos estará deshabilitada.',
  CREATE_BATCH_PAYMENT: 'Crear Pago en Lote',
  CREATE_BATCH_PAYMENTS: 'Crear Pagos en Lote',
  CONFIRM_DOCUMENTS: '¡Confirmar Documentos!',
  BANK_REMIT: 'Remesa Bancaria',
  DEBTOR_REMIT: 'Remesa del Cliente',
  OTHER_DOCUMENT: 'Otro',
  DOCUMENT_TYPE: 'Tipo de Documento',
  ADD_MORE_DOCUMENTS: 'Agregar Más Documentos',
  CREATE_PAYMENTS: 'Crear Pagos',
  APPLY_PAYMENTS: 'Aplicar Pagos',
  EDIT_PAYMENT: 'Editar Pago',
  CONFIRM: 'Confirmar',
  FORCE_CLOSE: 'Forzar Cierre',
  MESSAGE_FORCE_CLOSE: '¿Está seguro de forzar el cierre de este lote de pagos?',
  PAYMENT_NOT_NEGATIVE: 'El monto del pago no puede ser negativo',
  SELECTED_DOCUMENTS_ENABLED_PAYMENT: 'Seleccione documentos para habilitar la asignación de pagos',
  DOCUMENTS_UPLOAD_ERROR: 'Los siguientes archivos tuvieron problemas al intentar cargarlos.',
  DOCUMENTS_UPLOAD_INFO_TEXT:
    'Ha ocurrido un error, para continuar por favor fuerce el cierre del lote de pagos actual. Presione Forzar cierre.',
  HAVE_CREATED_QUEUE: 'Ya tiene una cola guardada.',
  REPLACE_QUEUE_CONFIRMATION: '¿Desea reemplazarla con la selección actual?',
  REPLACE: 'Reemplazar',
  CLEAR_QUEUE: 'Limpiar cola',
  QUEUE_PAYMENTS: 'Cola de pagos',
  APPLYING: 'Aplicando',
  CLEAR_PAYMENT_QUEUE: 'Limpiar cola de pagos',
  MESSAGE_CLEAR_PAYMENT_QUEUE: '¿Está seguro de que desea limpiar la cola de pagos?',
  QUEUE_PROCESSING_COMPLETE: 'Ha aplicado con éxito todos los pagos en la cola, la cola ha sido limpiada.',
  CONTINUE_QUEUE: 'Continuar cola',
  PAYMENT_LIST_QUEUE_MESSAGE: 'Actualmente tiene una cola activa. Puede realizar una de estas acciones en ella.',
  PAYMENT_ORIGINAL_INFORMATION: 'Información original del pago',
  ORIGINAL_PAYMENT: 'Pago original',
  ORIGINAL_AMOUNT: 'Monto original',
  SPLIT_DATE: 'Fecha de división',
  GENERATED_PAYMENT_SPLIT: 'División de pago generada',
  PAYMENT_SPLIT_INFORMATION: 'Información de división de pago',
  SPLIT_INFORMATION: 'Información de división',
  // END Fabian
  //BEGIN Esteban
  PAYMENT_UPDATE: 'Actualizar pago',
  PAYMENT_UPDATE_SUCCESS: 'Pago actualizado exitosamente',
  ONLY_ZERO_BALANCE: 'Facturas saldo cero',
  IMPORT_INVOICES: 'Importar Facturas',
  ALERT_INVOICE_CSV: 'Solo se permite un archivo y debe ser un archivo .csv.',
  INVOICE_CSV_SUCCESS: 'Las facturas se han agregado correctamente.',
  WITHDRAW_PAYMENT: 'Deshacer pago',
  WITHDRAW_DIALOG_FIRST_BODY_TEXT: '¿Está seguro de que desea deshacer el pago seleccionado?',
  CONFIRM_WITHDRAW: 'Confirmar deshacer',
  UNABLE_TO_WITHDRAW_PAYMENT_APPLIED: 'El pago solo puede ser deshecho el mismo día que fue aplicado.',
  UNABLE_TO_WITHDRAW_PAYMENT_HAS_CREDIT: 'Este pago no puede ser retirado porque generó un crédito.',
  WITHDRAW_PAYMENTS_SUCCESS: 'Pagos deshechos exitosamente',
  DOWNLOAD_NACHA_FILE: 'Descargar archivo NACHA',
  DOWNLOAD_NACHA_FILE_V1: 'Descargar archivo NACHA V1',
  DOWNLOAD_NACHA_FILE_V2: 'Descargar archivo NACHA V2',
  BODY_DOWNLOAD_NACHA_FILE: '¿Desea descargar el archivo NACHA?',
  EXPORT_NACHA_FILE_SUCCEED: 'Archivo NACHA exportado exitosamente',
  DOWNLOAD_EFT_FILE: 'Descargar archivo EFT',
  BODY_DOWNLOAD_EFT_FILE: '¿Desea descargar el archivo EFT?',
  EXPORT_EFT_FILE_SUCCEED: 'Archivo EFT exportado exitosamente. Ya está listo para descargar.',
  EXPORT_EFT_FILE_FAILED: 'No se pudo exportar el archivo EFT. Intente de nuevo.',
  DOWNLOAD_EFT_FILE_CAD: 'Descargar archivo EFT CAD',
  DOWNLOAD_EFT_FILE_USD: 'Descargar archivo EFT USD',
  DOWNLOAD_EFT_FILE_CURRENCY: 'Descargar archivo EFT {currency}',
  EXPORT_EFT_FILE_SUCCEED_CURRENCY:
    'Archivo EFT {currency} exportado exitosamente. Ya está listo para descargar.',
  EXPORT_EFT_FILE_FAILED_CURRENCY: 'No se pudo exportar el archivo EFT {currency}. Intente de nuevo.',
  PAYMENT_CHANNEL: 'Canal de pago',
  //END Esteban

  // BEGIN Patricio
  DOWNLOAD_DISBURSEMENT_CSV: 'Descargar CSV',
  BODY_DOWNLOAD_DISBURSEMENT_CSV: '¿Está seguro que desea descargar el archivo CSV de Desembolso?',
  // END Patricio
  FULL: 'Completo',
  SHORT_FULL: 'Corto Completo',

  PREVIEW_BALANCE_LESS_THAN_PAYMENT_TOTAL: 'El balance de vista previa es menor que el total del pago',
  PREVIEW_BALANCE_EXCEEDS_PAYMENT_TOTAL: 'El balance de vista previa excede el total del pago',
  PREVIEW_BALANCE_PAID_IN_FULL: 'El balance de vista previa está pagado en su totalidad',

  BATCH_NUMBER: 'Número de lote',
  BATCH_USER: 'Usuario de lote',
  CREATE_BATCH: 'Crear lote',
  CREATE_PAYMENT_BATCH: 'Crear lote de pagos',
  PAYMENT_BATCH_CREATED_SUCCESSFULLY: 'Lote de pagos creado exitosamente',
  UNABLE_TO_BATCH_PAYMENT:
    'No se puede crear un lote cuando un pago seleccionado no está sin aplicar o ya pertenece a un lote',

  // Reconciliation
  RECONCILE_DRAFT_PAYMENTS: 'Conciliar Pagos en Borrador',
  RECONCILIATION: 'Conciliación',
  DEBTOR_REMITTANCE: 'Remesa del Cliente',
  BANK_REMITTANCE: 'Remesa Bancaria',
  RECONCILIATION_STATUS: 'Estado',
  READY_TO_APPLY: 'Listo para Aplicar',
  MISMATCH: 'Discrepancia',
  MISSING_BANK_REMIT: 'Falta Remesa Bancaria',
  MISSING_DEBTOR_REMIT: 'Falta Remesa del Cliente',
  LIKELY_MATCH: 'Coincidencia Probable',
  POTENTIAL_MATCH: 'Coincidencia Potencial',
  POSSIBLE_MATCH: 'Coincidencia Posible',
  USER_MATCH: 'Coincidencia de Usuario',
  UNMATCH: 'Desemparejar',
  DELETE_DEBTOR_RM: 'Eliminar Remesa del Cliente',
  DELETE_BANK_RM: 'Eliminar Remesa Bancaria',
  MOVE_BANK_REMITTANCE: 'Mover Remesa Bancaria',
  MOVE_DEBTOR_REMITTANCE: 'Mover Remesa del Cliente',
  SEARCH_DEBTOR_REMITTANCE: 'Buscar Remesa del Cliente',
  SEARCH_BANK_REMITTANCE: 'Buscar Remesa Bancaria',
  MATCH_TO_SELECTED: 'Emparejar con Remesa del Cliente Seleccionada',
  MATCH_TO_SELECTED_BANK: 'Emparejar con Remesa Bancaria Seleccionada',
  NO_PAYMENTS_TO_RECONCILE: 'No hay pagos disponibles para conciliar.',
  CONFIRM_DELETE_DEBTOR_RM_TITLE: 'Eliminar Remesa del Cliente',
  CONFIRM_DELETE_DEBTOR_RM_MESSAGE: '¿Está seguro de que desea eliminar este pago de Remesa del Cliente?',
  CONFIRM_DELETE_BANK_RM_TITLE: 'Eliminar Remesa Bancaria',
  CONFIRM_DELETE_BANK_RM_MESSAGE: '¿Está seguro de que desea eliminar este pago de Remesa Bancaria?',
  CREATE_PAYMENT_FROM_RECONCILE: 'Crear Pago',
  CREATE_SELECTED_PAYMENTS: 'Crear Pagos Seleccionados',
  PAYMENTS_CREATED_SUCCESSFULLY: 'Pagos creados exitosamente',

  OVER_ADVANCE_DETAILS: 'Detalles de Sobre Anticipo',
  OVER_ADVANCE_TYPE: 'Tipo de Sobre Anticipo',
  WITHDRAW_OVER_ADVANCE_PAYMENT: 'Deshacer Pago de Sobre Anticipo',
  WITHDRAW_OVER_ADVANCE_DIALOG_BODY: '¿Está seguro de que desea deshacer este pago del sobre anticipo?',
  WITHDRAW_OVER_ADVANCE_SUCCESS: 'Pago deshecho del sobre anticipo exitosamente',
}
